var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="context-bar-content-calc-working"> <div class="progress margin-right-ms-4 margin-left-ms-4 margin-bottom-0"> <div class="progress-bar progress-bar-calc-loading progress-bar-striped active"style="width: 100%"data-bind="style: { width: _normalizedProgress() + \'%\' }"> <span data-bind="text: _message()"> пожалуйста подождите </span> </div> </div> </div>';
}
return __p;
};
